export default __webpack_public_path__ + "static/titilliumweb-light-webfont-4facf03b0508ab4cbd033d85ca22616d.eot";